import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import IconCategoryValue from '../IconCategoryValue';
import i18n from '../../../src/i18n/translate';

const SelectedItemsRibbon = ({ count = 0, onClearSelection, tooltip, warning, icon }) => {
  count = count || 0;
  if (count === 0 && !warning && !tooltip) {
    return null;
  }

  let children;

  if (warning) {
    children = (
      <IconCategoryValue
        color="blue"
        icon="alert-triangle"
        value={warning}
        tooltip={tooltip} />
    );
  } else {
    children = (
      <>
        <IconCategoryValue
          color="blue"
          icon={icon}
          category={i18n.t('Selected Items')}
          value={count.toLocaleString('en')}
          tooltip={tooltip} />
        {count > 0 && onClearSelection && <Button
          label={i18n.t('Unselect All')}
          style="link"
          onClick={onClearSelection} />}
      </>
    );
  }

  return (
    <div className="selected-items-ribbon">
      {children}
    </div>
  );
}

SelectedItemsRibbon.propTypes = {
  count: PropTypes.number,
  icon: PropTypes.string,
  warning: PropTypes.string,
  tooltip: PropTypes.string,
  onClearSelection: PropTypes.func
}

export default SelectedItemsRibbon;
